import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getWatersupplyData(context) {
      const response = await Vue.axios.get(`${URL_API}watersupply`);
      let data = response["data"];
      context.commit("updateWatersupplyData", data);
    },
    async createWatersupplyData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}watersupply/store`, body, config);
      context.dispatch("getWatersupplyData");
    },
    async pushWatersupplyData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}watersupply/update`, body, config);
      context.dispatch("getWatersupplyData");
    },
    async destroyWatersupplyData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}watersupply/destroy`, body, config);
      context.dispatch("getWatersupplyData");
    }
  },
  mutations: {
    updateWatersupplyData(state, watersupplyData) {
      state.watersupplyData = watersupplyData;
    }
  },
  state: {
    watersupplyData: []
  },
  getters: {
    allWatersupplyData(state) {
      return state.watersupplyData;
    }
  }
};